import React from 'react';

export default function BootcampPaymentPlans({ plans, selectedKey, onSelect }) {
  if (!plans.length) return null;
  return (
    <fieldset className="v2-payment-plans">
      <legend>Choose your payment schedule</legend>
      {plans.map((plan) => (
        <label className="v2-payment-row" key={plan.planKey}>
          <input
            type="radio"
            name="bootcamp-payment-plan"
            value={plan.planKey}
            checked={selectedKey === plan.planKey}
            onChange={() => onSelect(plan.planKey)}
          />
          <span className="v2-payment-name">
            {plan.installments > 1 ? `${plan.installments} monthly payments` : 'Pay in full'}
          </span>
          <span className="v2-payment-amount">
            <strong>
              {plan.display}
              {plan.installments > 1 ? '/mo' : ''}
            </strong>
            <span>{plan.installments > 1 ? `${plan.totalDisplay} total` : 'One payment'}</span>
          </span>
        </label>
      ))}
    </fieldset>
  );
}
